"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _readOnlyError2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/readOnlyError.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * info:
 * step3 TPP记录 page
 * 该页面只读
 */
var _default2 = exports.default = {
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // tpp详情，从门店信息api读取出
    tppinfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      /** 变更记录 table group */
      logTable: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null // api timer
      },
      /** TPP信息 table group */
      TPPTable: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null // api timer
      }
    };
  },
  computed: {
    tppUpdateHistories: function tppUpdateHistories() {
      var _ref = this.tppinfo || {},
        tppUpdateHistories = _ref.tppUpdateHistories;
      return tppUpdateHistories || [];
    },
    tppInfoVos: function tppInfoVos() {
      var _ref2 = this.tppinfo || {},
        tppInfoVos = _ref2.tppInfoVos;
      return tppInfoVos || [];
    }
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft() {
      console.log('保存草稿');
      this.$emit('draft');
    },
    // 下一步
    onNext: function onNext() {
      console.log('下一步');
      this.$emit('next');
    }
  }
};